import { useMemo } from 'react';

import adminReturnOrderService from '@services/admin/returnOrderService';

/**
 * Admin ReturnOrder Service Hook
 *
 * 簡單包裝 adminReturnOrderService，保持與 operator hook 的一致性
 *
 * @returns {Object} returnOrderService
 *
 * @example
 * const returnOrderService = useAdminReturnOrderService();
 *
 * await returnOrderService.create({ name: 'RO001', order_id: 1, status: 'pending' });
 * await returnOrderService.getById(1);
 */
export function useAdminReturnOrderService() {
  return useMemo(() => adminReturnOrderService, []);
}
